import { useQuery } from "@tanstack/react-query";
import instance from "services/axiosServices";

export function useListarZonasEmpreendimentos() {
  const fetchData = async () => {
    const LISTAR_ZONAS_EMPREENDIMENTOS = `locais/mobile/zonas-empreendimentos/v1`;
    const response = await instance.get(LISTAR_ZONAS_EMPREENDIMENTOS);
    const dataWithPagination = {
      data: response?.data?.data,
      pagination: response?.data?.pagination,
    };
    return dataWithPagination;
  };
  const query = useQuery({
    queryFn: () => fetchData(),
    refetchOnWindowFocus: false,
    queryKey: ["listar_zonas_empreendimentos"],
    refetchOnMount: false,
    enabled: true,
  });
  return query;
}
